import { configureStore } from "@reduxjs/toolkit"
import * as Sentry from "@sentry/react"
import createSagaMiddleware from "redux-saga"

import rootReducer from "./reducers"
import rootSaga from "./sagas"
import { apiV1 } from "./api/apiV1"
import { apiV2 } from "./api/apiV2"

const sagaMiddleware = createSagaMiddleware()

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(apiV1.middleware)
      .concat(apiV2.middleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
  devTools: true,
})

sagaMiddleware.run(rootSaga)

export default store
